// Раздел «Отчеты» (перенос из старого Office: Отчеты, Отчеты для руководителей, Генератор отчетов, Финансы).
// Все отчёты — одна общая страница /office/reports/r/<код>, описание отчёта — src/views/office/reports/configs/*.js
// (там же свой компонент для сложных экранов). Ключ pages = menu_action пункта меню (office_port/areas/reports/menu.py).
const R = (code) => `/office/reports/r/${code}`;

export const pages = {
  officeRepSalesDept: R("sales-department"),
  officeRepManualPlan: R("manual-plan"),
  officeRepDsUnaccepted: R("ds-unaccepted"),
  officeRepOkk: R("okk"),
  officeRepOkkCheckHistory: R("okk-check-history"),
  officeRepCompletedRemont: R("completed-remont"),
  officeRepCompletedCheckGroup: R("completed-check-group"),
  officeRepCompletedStageMp: R("completed-stage-mp"),
  officeRepStageReady: R("stage-ready"),
  officeRepResidentDraft: R("resident-draft"),
  officeRepCheckListOkk: R("check-list-okk"),
  officeRepWorkDuration: R("work-duration"),
  officeRepDiffSmeta: R("difference-smeta"),
  officeRepOkkWorkload: R("okk-workload"),
  officeRepDocsOkk: R("docs-okk"),
  officeRepAktSverki: R("akt-sverki"),
  officeRepContractorFutureCapacity: R("contractor-future-capacity"),
  officeRepMaterialShipmentGraph: R("material-shipment-graph"),
  officeRepProviderRequestsMaterials: R("provider-requests-materials"),
  officeRepMaterialShipping: R("material-shipping"),
  officeRepContractorCompletedStage: R("contractor-completed-stage"),
  officeRepLogistics: R("logistics"),
  officeRepOpenRemontDefect: R("open-remont-defect"),
  officeRepRequestedMaterials: R("requested-materials"),
  officeRepForRequestedMaterials: R("for-requested-materials"),
  officeRepChangedMaterial: R("changed-material"),
  officeRepProviderRequestInvoice: R("provider-request-invoice"),
  officeRepProviderNotShipped: R("provider-not-shipped"),
  officeRepProviderPayment: R("provider-payment"),
  officeRepClientRequestPayment: R("client-request-payment"),
  officeRepTabletop: R("tabletop"),
  officeRepFinanceContractor: R("finance-contractor"),
  officeRepAllRemontPayment: R("all-remont-payment"),
  officeRepContractorCapacity: R("contractor-capacity"),
  officeRepNps: R("nps"),
  // пункты, не перенесённые (страница с причиной): меню уже создано в dev, apply_menu строки не удаляет
  officeRepRemontRealisation: R("remont-realisation"),
  officeRepManagementGrt: R("management-grt"),
  officeRepMpMaterial: R("manager-project-material"),
  officeRepRealisationList: R("realisation-list"),
  officeRepGenSettings: R("generator-settings"),
  officeMngReportList: R("mng-settings"),
  officeMngReportGroupList: R("mng-groups"),
  officeMngActionList: R("mng-actions"),
  officeRepEmployeeResident: R("employee-resident"),
  officeRepBuhCorrection: R("buh-correction"),
  officeRepBuhManualOperation: R("buh-manual-operation"),
};

export const routes = [
  {
    path: "/office/reports/r/:code",
    name: "officeReportsGeneric",
    meta: { layout: "main", title: "Отчеты (Office)" },
    component: () => import("@/views/office/reports/ReportPage.vue"),
  },
  {
    // карточки/вложенные страницы сложных экранов (настройка отчёта, группы и т.п.)
    path: "/office/reports/r/:code/:id",
    name: "officeReportsGenericItem",
    meta: { layout: "main", title: "Отчеты (Office)" },
    component: () => import("@/views/office/reports/ReportPage.vue"),
  },
];
